import React from 'react';
import { FormattedMessage } from 'react-intl';
import PropTypes from 'prop-types';

import SvgArmstrongFeedback from './feedback-icon';
import {
  StyledBodyCopy,
  StyledLink,
  StyledMetaNoMargin,
  StyledContent,
  StyledContainer,
} from './feedback-and-help.styles';

const FeedbackAndHelp = ({ onClick, hashedUserId }) => {
  return (
    <StyledContainer>
      <StyledLink
        onClick={onClick}
        to={`https://easy-feedback.de/umfrage/1258999/0ctD2q/pi${hashedUserId}=feedback_info_easyfeedback_survey_click`}
      >
        <StyledContent>
          <SvgArmstrongFeedback />
        </StyledContent>
        <StyledContent>
          <StyledBodyCopy size="medium">
            <FormattedMessage id={'FRAME_NAVIGATION_FEEDBACK_AND_HELP_TITLE'} />
          </StyledBodyCopy>
          <StyledMetaNoMargin size="small">
            <FormattedMessage
              id={'FRAME_NAVIGATION_FEEDBACK_AND_HELP_SUBTITLE'}
            />
          </StyledMetaNoMargin>
        </StyledContent>
      </StyledLink>
    </StyledContainer>
  );
};

FeedbackAndHelp.displaName = 'FeedbackAndHelp';

FeedbackAndHelp.propTypes = {
  onClick: PropTypes.func,
  hashedUserId: PropTypes.string,
};

export { FeedbackAndHelp };
